import {useEffect} from "react";
import {useRouteMatch} from "react-router";
import { PaymentBroadcaseMessage } from "../deposit/OpenInNewWindow";

export const MayaPaymentAuth = () => {

    // let match = useRouteMatch<{result?: "success" | "error"}>();
    const getParams = () =>{
        const token = new URLSearchParams(document.location.search).get("code")
        const state = new URLSearchParams(document.location.search).get("state")
        const profileId = new URLSearchParams(document.location.search).get("profileId")

        try {
            const channel = new BroadcastChannel('exit-payment');

            const msg: PaymentBroadcaseMessage = {type: "auth", status: "success", context: { provider: "maya", token: token, requestUid: state, profileId: profileId }}
            channel.postMessage(msg);
        } catch (e) {}

        window.close();
    }
    useEffect(()=>{
        getParams();
    },[])

    return (
        <div>

        </div>
    )
}
export default MayaPaymentAuth;